// App.js
import React, { useState, useEffect } from "react";
import { useLocation, Routes, Route, NavLink, Navigate } from "react-router-dom";
import { SiteStateProvider } from "./starsonata/SiteStateContext";
import Home from "./main/Home";
import News from "./main/News";
import logo from "./main_media/logo.png";
import PrivacyPolicy from "./main/PrivacyPolicy";
import ScanDetails from "./starsonata/ScanDetails";
import Proddy from "./starsonata/imp_only/Proddy";
import GameContentDynamic from "./main/GameContentDynamic";
import ImperiumScans from "./starsonata/ImperiumScans";
import "./css/App.css";
import AuthModal from "./starsonata/AuthModal";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./starsonata/firebase";
import TeamDashboard from "./starsonata/TeamDashboard";
import TeamScans from "./starsonata/TeamScans";
import TeamProddy from "./starsonata/TeamProddy";
import TeamLeaderPanel from "./starsonata/TeamLeaderPanel";
import StarSonataLayout from "./starsonata/StarSonataLayout";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./starsonata/firebase";
import useUserData from "./hooks/useUserData";

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [communityDropdownOpen, setCommunityDropdownOpen] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const location = useLocation();

  const isSpecial =
    location.pathname.startsWith("/starsonata") ||
    location.pathname.startsWith("/scandetails") ||
    location.pathname.startsWith("/proddy");

  const { userData } = useUserData();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => setCurrentUser(user));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const applyTeamTheme = async () => {
      if (userData?.teamId) {
        const teamRef = doc(db, "teams", userData.teamId);
        const snap = await getDoc(teamRef);
        if (snap.exists()) {
          const team = snap.data();
          document.documentElement.style.setProperty('--theme-color', team.themeColor || "#330055");
          document.documentElement.style.setProperty('--theme-hover-color', team.hoverColor || "#2a2a2a");
          document.documentElement.style.setProperty('--theme-text-color', team.textColor || "#fff");
        }
      }
    };
    applyTeamTheme();
  }, [userData]);

  useEffect(() => {
    const link = document.createElement("link");
    link.id = "conditional-css";
    link.rel = "stylesheet";
    link.href = isSpecial ? "/specialNav.css" : "/defaultNav.css";
    document.getElementById("conditional-css")?.remove();
    document.head.appendChild(link);
  }, [location.pathname, isSpecial]);

  useEffect(() => {
    document.body.style.backgroundColor = isSpecial ? "#313131" : "white";
  }, [isSpecial]);

  const handleLogout = async () => {
    await signOut(auth);
    setCurrentUser(null);
  };


  return (
    <SiteStateProvider>
    <div>
      <nav className={`navbar ${isSpecial && currentUser ? "team-navbar" : ""}`}>
        {isSpecial ? (
          <div className="team-header">
            <img src={`https://www.starsonata.com/images/team_flags/game/${userData?.teamId}`} alt="Team Logo" className="team-logo" />
            <span className="team-name-only">{userData?.teamName || "Team"}</span>
            <img src={`https://www.starsonata.com/images/team_flags/game/${userData?.teamId}`} alt="Team Logo" className="team-logo" />
          </div>
        ) : (
          <div className="logo-container">
            <img src={logo} alt="Logo" className="logo" />
          </div>
        )}

        <div className="nav-menu">
          {isSpecial ? (
            <>
              <NavLink to="/starsonata/team" className="nav-link" end>Dashboard</NavLink>
              <NavLink to="/starsonata/team/scans" className="nav-link">Scans</NavLink>
              <NavLink to="/starsonata/team/proddy" className="nav-link">Proddy</NavLink>
              {userData?.role === "leader" && userData?.verified && (
                <NavLink to="/starsonata/team/leader" className="nav-link">Leader Panel</NavLink>
              )}
             {currentUser ? (
  <div className="user-info-special">
    Welcome, {currentUser.displayName || "user"}!
    <span
      onClick={handleLogout}
      style={{
        marginLeft: "10px",
        textDecoration: "underline",
        cursor: "pointer",
      }}
    >
      Logout
    </span>
  </div>
) : (
  <button onClick={() => setShowAuthModal(true)} className="nav-link" style={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)" }}>
    Account
  </button>
)}
            </>
          ) : (
            <>
              <NavLink to="/" className="nav-link" end>HOME</NavLink>
              <div
                className="dropdown"
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <button className="nav-button">OUR GAMES ▼</button>
                {dropdownOpen && (
                  <div className="dropdown-content">
                    <NavLink to="/game/kaos" className="dropdown-link">KAOS LAST STAND</NavLink>
                    <NavLink to="/game/window" className="dropdown-link">WINDOW OF OPPORTUNITY</NavLink>
                    <NavLink to="/game/essentials" className="dropdown-link">JUST THE ESSENTIALS</NavLink>
                    <NavLink to="/game/limitless" className="dropdown-link">LIMITLESS: EARTH DEFENCE</NavLink>
                    <NavLink to="/game/cropagation" className="dropdown-link">CROPAGATION</NavLink>
                  </div>
                )}
              </div>
              <div
                className="dropdown"
                onMouseEnter={() => setCommunityDropdownOpen(true)}
                onMouseLeave={() => setCommunityDropdownOpen(false)}
              >
                <button className="nav-button">COMMUNITY ▼</button>
                {communityDropdownOpen && (
                  <div className="dropdown-content">
                    <a href="https://discord.gg/nk3kCR97Ny" target="_blank" rel="noopener noreferrer" className="dropdown-link">
                      DISCORD
                    </a>
                  </div>
                )}
              </div>
              <NavLink to="/contact" className="nav-link">CONTACT</NavLink>
              <NavLink to="/privacy" className="nav-link">PRIVACY</NavLink>
              <NavLink to="/starsonata" className="nav-link">STAR SONATA</NavLink>
            </>
          )}
        </div>
      </nav>

      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<div>email: support@slypandainteractive.com</div>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/proddy" element={<Proddy />} />
          <Route path="/game/:gameId" element={<GameContentDynamic />} />
          <Route path="/scandetails/:galaxy" element={<ScanDetails />} />
          <Route path="/starsonata" element={ currentUser ? <Navigate to="/starsonata/team" replace /> : <StarSonataLayout /> }/>
          <Route path="/starsonata" element={<StarSonataLayout />}>
            <Route path="team" element={<TeamDashboard />} />
            <Route path="team/scans" element={<TeamScans />} />
            <Route path="team/proddy" element={<TeamProddy />} />
            <Route path="team/leader" element={<TeamLeaderPanel />} />
          </Route>
        </Routes>
      </div>

      {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
    </div>
    </SiteStateProvider>
  ) ;/////d
}

export default App;
